module.exports = __webpack_public_path__ + "img/i_t_1.5dac8591.png";